import { Format, Timestamp } from "shared-ts/classes/timestamp"

import { data } from "./data"
import { TypedAccessor } from "./types"
import { TableCellWidth } from "../TableCell"
import { DataColumn } from "../useTable/types"

type DateAccessorFn<T> = TypedAccessor<
  T,
  Date | { date: Date; timeZone: string } | undefined
>

interface DateColumn<T>
  extends Omit<DataColumn<T>, "type" | "renderCell" | "width"> {
  width?: DataColumn<T>["width"]
}

export type DateColumnHelper<T> = (
  accessorFn: DateAccessorFn<T>,
  format: Format,
  col: DateColumn<T>
) => DataColumn<T>

export function date<T>(
  accessorFn: DateAccessorFn<T>,
  format: Format,
  col: DateColumn<T>
): DataColumn<T> {
  const { width, ...restCol } = col
  return data({
    renderCell: (rowData) => {
      const value = accessorFn(rowData)
      if (!value) return "—"

      if (value instanceof Date) {
        return Timestamp.formatDate(format, value)
      }

      const { date, timeZone } = value
      return Timestamp.formatDate(format, date, timeZone)
    },

    width: width ?? TableCellWidth.Medium,
    ...restCol,
  })
}
